/*global L, SOS_LOCATION_MARKERS, SOS_LOCATION_BOUNDS*/
document.getElementById("map").removeAttribute("x-cloak");

var map = L.map("map", {
  maxBounds: [
    [-90, -180],
    [90, 180],
  ],
}).fitBounds(SOS_LOCATION_BOUNDS);

L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
  attribution:
    '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
}).addTo(map);

var i, n, loc;

for (i = 0, n = SOS_LOCATION_MARKERS.length; i < n; i++) {
  loc = SOS_LOCATION_MARKERS[i];
  L.marker(loc.latLng, { title: loc.name, alt: loc.name })
    .addTo(map)
    .bindPopup(loc.name);
}
